import { Link } from "react-router-dom";
import { ArrowLeft, Ban } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-lg bg-white border-2 border-[#0A0A0A] brutal-shadow p-10" data-testid="payment-cancel-panel">
        <div className="w-16 h-16 border-2 border-[#0A0A0A] bg-[#FFD600] flex items-center justify-center mb-6">
          <Ban size={34} strokeWidth={2.5} className="text-[#0A0A0A]" />
        </div>
        <div className="font-mono-b text-xs uppercase tracking-[0.3em] text-[#0A0A0A]/60 mb-3">[ CHECKOUT CANCELLED ]</div>
        <h1 className="font-display font-extrabold text-4xl tracking-tighter">No charge made</h1>
        <p className="mt-4 text-sm text-[#0A0A0A]/70 leading-relaxed">
          You cancelled before completing payment. Nothing was charged and no access was granted.
          You can pick a plan again whenever you're ready.
        </p>
        <Link to="/#pricing" className="mt-8 inline-flex items-center gap-2 bg-[#FF3B30] text-white font-mono-b uppercase tracking-[0.15em] text-sm px-6 py-3 border-2 border-[#0A0A0A] brutal-shadow-sm hover:-translate-y-1 transition-transform duration-200" data-testid="back-to-pricing-button">
          <ArrowLeft size={16} strokeWidth={2.5} /> Back to pricing
        </Link>
      </div>
    </div>
  );
}
